<div class="h-full pb-10 transition-all ease-in-out duration-150 absolute lg:relative z-50 bg-white border-r"
    [ngClass]="{'w-full md:w-64 px-4': utilService.navbarOpen, 'w-0': !utilService.navbarOpen}">

    <div [ngClass]="{'opacity-0 delay-300 hidden': !utilService.navbarOpen}" class="space-y-1 h-full flex flex-col">
        <div class="flex py-4 space-y-2 self-center" [routerLink]="'/'">
            <div class="w-full flex items-center justify-start">
                <img src="assets/images/logo2.png" class="w-32">
            </div>
        </div>

        <div class="flex-1 overflow-y-auto min-h-0 h-full pb-24 space-y-1">
            <div *ngFor="let menu of menuList">
                <div *ngIf="menu.section && menu.visible && utilService.navbarOpen && (!menu.requiresBranch || hasBranchChannel)"
                    class="flex items-center gap-3 px-3 pt-6 pb-3">
                    <div class="text-sm font-bold text-primary-600 uppercase tracking-[0.15em] whitespace-nowrap">
                        {{ menu.section }}
                    </div>
                    <div class="flex-1 h-0.5 bg-gradient-to-r from-primary-200/70 to-transparent rounded-full"></div>
                </div>
                <ng-container
                    *ngIf="!menu.section && menu.visible && (!menu.requiresBranch || hasBranchChannel) && (authGuardService.canAccessRoute(menu.path) || subMenuCanAccess(menu?.submenu || []))">
                    <button
                        [ngClass]="{'bg-primary-500 text-white hover:bg-primary-500': activeMainMenu === menu.path &&  !menu.isShowSub, 'hover:bg-gray-200 text-gray-700': activeMainMenu !== menu.path, 'text-black': utilService.navbarOpen && menu.submenu && menu.isShowSub}"
                        class="flex flex-row space-x-2 h-10 w-full items-center px-3 rounded"
                        (click)="menu.submenu ? openSubMenu(menu) : routerPath(menu)">
                        <div class="flex w-7 justify-center items-center">
                            <fa-icon [ngClass]="{'text-white' : activeMainMenu === menu.path && !menu.isShowSub }"
                                class="text-lg text-gray-300 duration-150" [icon]="menu.icon"></fa-icon>
                        </div>
                        <div *ngIf="utilService.navbarOpen" class="w-full flex flex-row items-center justify-between">
                            <div>{{menu.name}}</div>
                            <fa-icon *ngIf="menu.submenu" class="text-xs transition-all ease-in-out duration-300"
                                [icon]="faChevronDown" [ngClass]="{'rotate-180':menu.isShowSub}"></fa-icon>
                        </div>
                    </button>

                    <div class="grid transition-all duration-300 ease-in-out"
                        [ngClass]="{'grid-rows-[1fr] opacity-100': menu.isShowSub, 'grid-rows-[0fr] opacity-0': !menu.isShowSub}">
                        <div class="overflow-hidden">
                            <div *ngIf="utilService.navbarOpen"
                                class="ml-5 pl-3 border-l border-gray-200 space-y-0.5 py-1 mt-1">
                                <ng-container *ngFor="let sub of menu.submenu">
                                    <button *ngIf="sub.visible && authGuardService.canAccessRoute(sub.path)"
                                        [ngClass]="{
                                          'bg-primary-50 text-primary-600 font-medium': activePath === sub.path,
                                          'text-gray-600 hover:bg-gray-100 hover:text-gray-900': activePath !== sub.path
                                        }"
                                        class="flex items-center w-full h-9 px-3 rounded-md text-sm transition-colors"
                                        [routerLink]="[sub.path]">
                                        <span class="w-1.5 h-1.5 rounded-full mr-2.5 flex-none transition-colors"
                                            [ngClass]="{'bg-primary-500': activePath === sub.path, 'bg-gray-300': activePath !== sub.path}">
                                        </span>
                                        <span class="truncate">{{sub.name}}</span>
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>


        <div class="flex-none w-full bg-white absolute bottom-0 left-0 px-4 py-3 space-y-2 border-t">
            <button class="flex items-center w-full space-x-2 hover:bg-gray-100 rounded p-1" routerLink="/profile">
                <img class="rounded-full bg-gray-100 h-9 w-9 flex-none"
                    [src]="user?.pictureUrl" alt="user" loading="lazy"
                    onerror="this.onerror=null; this.src='assets/images/user.png'">
                <div *ngIf="utilService.navbarOpen" class="flex-1 min-w-0 text-left">
                    <div class="text-sm font-bold truncate">{{user?.displayName || ''}}</div>
                    <div class="text-xs text-gray-600 truncate">
                        {{permissionService.getRole(user?.role || '')}}
                    </div>
                </div>
            </button>
            @if(utilService.navbarOpen){
            <div class="md:hidden w-full flex space-x-2 justify-center cursor-pointer" (click)="switchSidenav()">
                <fa-icon class="" [icon]="faXmark"></fa-icon>
                <div class="">ปิด</div>
            </div>
            }
        </div>
    </div>

</div>
<div [ngClass]="{'fixed lg:hidden top-0 left-0 bg-black opacity-10 w-screen h-screen z-40': utilService.navbarOpen, 'hidden': !utilService.navbarOpen}"
    (click)="switchSidenav()">
</div>
<button class="hidden md:flex fixed top-1/2 -translate-y-1/2 z-50 bg-white shadow-md hover:bg-gray-100 transition-all duration-150 h-10 w-6 items-center justify-center rounded-r border-y border-r border-gray-200"
    [ngClass]="{ 'left-64': utilService.navbarOpen, 'left-0': !utilService.navbarOpen }"
    (click)="switchSidenav()" title="{{ utilService.navbarOpen ? 'ย่อเมนู' : 'ขยายเมนู' }}">
    <fa-icon class="text-xs text-gray-600"
        [icon]="utilService.navbarOpen ? faChevronLeft : faChevronRight"></fa-icon>
</button>

<button *ngIf="!utilService.navbarOpen"
    class="md:hidden fixed top-2 left-2 z-40 bg-white rounded shadow-md h-10 w-10 flex items-center justify-center"
    (click)="switchSidenav()">
    <fa-icon [icon]="faBars"></fa-icon>
</button>